import React from "react";
import DateSection from "./DateSection";
import AccommodationSection from "./AccommodationSection";

class RoomDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    
    return (
      <div className="col-md-6 RoomDetails">
        <div className="panel panel-default">
          <div className="panel-heading flexed">
            <div className="col-md-6 panel-title-wrapper">
              <h3 className="panel-title">{I18n.t("room_details")}</h3>
            </div>
            {this.props.reservation_segment &&
              this.props.reservation_segment.status != "canceled" &&
              this.props.reservation_segment.status != "checked_out" &&
              !this.props.read_only &&
              !this.props.loading ? (
              <div className="col-md-6 content-right flexed button-wrapper">
            
                {(this.props.reservation_segment &&
                  this.props.reservation_segment.status != "checked_in" &&
                  this.props.reservation_segment.status != "held" &&
                  this.props.reservation_segment.status != "no_show" &&
                  !this.props.read_only) ||
                 (this.props.past_check_in &&
                  this.props.reservation_segment &&
                  this.props.reservation_segment.status != "canceled" &&
                  this.props.reservation_segment.status != "held" &&
                  this.props.reservation_segment.status != "no_show" &&

                  !this.props.read_only) ? (
                  <button
                    type="button"
                    className={
                      "btn btn-sm btn-danger btn-sm modal-iframe segment-card-action-button"
                    }
                    data-fullscreen="true"
                    data-nested="true"
                    href={`/admin/reservation_segments/${this.props.reservation_segment.id}/cancel`}
                  >
                    {I18n.t("cancel")}
                  </button>
                  ) : null 
                }

                {(this.props.check_in_today &&
                  this.props.reservation_segment &&
                  this.props.reservation_segment.status != "canceled" &&
                  this.props.reservation_segment.status != "held" &&
                  this.props.reservation_segment.status != "no_show" &&

                  !this.props.read_only) ||
                  (this.props.past_check_in &&
                  !this.props.past_check_out &&
                  this.props.reservation_segment &&
                  this.props.reservation_segment.status != "canceled" &&
                  this.props.reservation_segment.status != "held" &&
                  this.props.reservation_segment.status != "no_show" &&

                  !this.props.read_only) ? (
                  <button
                    type="button"
                    className={
                      "btn btn-sm btn-success btn-sm modal-iframe segment-card-action-button"
                    }
                    data-fullscreen="true"
                    data-nested="true"
                    href={`/admin/reservation_segments/${this.props.reservation_segment.id}/check_in`}
                  >
                    {I18n.t("check_in")}
                  </button>
                  ) : null
                }
                {(!this.props.check_in_today &&
                  this.props.check_out_today &&
                  this.props.reservation_segment &&
                  this.props.reservation_segment.status == "checked_in" && 
                  !this.props.read_only) ||
                  (!this.props.check_in_today &&
                  this.props.past_check_out &&
                  this.props.reservation_segment &&
                  this.props.reservation_segment.status != "no_show" &&
                  !this.props.read_only) || 
                  (this.props.reservation_segment.status == "checked_in" && 
                    this.props.reservation_segment.room_type.type_of_booking == "daily" &&
                    !this.props.read_only) 
                  ? (
                  <button
                    type="button"
                    className={
                      "btn btn-sm btn-danger btn-sm modal-iframe segment-card-action-button"
                    }
                    data-fullscreen="true"
                    data-nested="true"
                    href={`/admin/reservation_segments/${this.props.reservation_segment.id}/check_out`}
                  >
                    {I18n.t("check_out")}
                  </button>
                  ) : null
                }

                {(this.props.reservation_segment.status != "no_show") ?

                  <button
                    type="button"
                    className={ "btn btn-primary btn-sm modal-iframe segment-card-action-button" }
                    data-fullscreen="true"
                    data-nested="true"
                    href={this.props.edit_segment_path}>
                    <span className="ss-write">
                      <span className="edit-span">{I18n.t("edit")}</span>
                    </span>
                  </button> : null
                }

                <button
                  type="button"
                  className={
                    "btn btn-secondary btn-sm modal-iframe segment-card-action-button"
                  }
                  data-fullscreen="true"
                  data-nested="true"
                  href={this.props.view_segment_path}
                >
                  <span className="view-span">{I18n.t("view")}</span>
                </button>


                {(this.props.reservation_segment && 
                this.props.reservation_segment.status == "checked_in" &&
                !this.props.past_check_out && 
                !this.props.read_only) 
                ?
                <button
                  type="button"
                  className={
                    "btn btn-sm btn-secondary modal-iframe segment-card-action-button"
                  }
                  data-fullscreen="false"
                  data-nested="true"
                  href={`/admin/reservation-segments/${this.props.reservation_segment.id}/undo_check_in`}
                >
                  {I18n.t("undo_check_in")}
                </button>
                :
                null
              }
              {(this.props.reservation_segment && 
                this.props.reservation_segment.status == "no_show" &&
                // !this.props.past_check_out && 
                !this.props.read_only) 
                ?
                <button
                  type="button"
                  className={
                    "btn btn-sm btn-secondary modal-iframe segment-card-action-button"
                  }
                  data-fullscreen="false"
                  data-nested="true"
                  href={`/admin/reservation-segments/${this.props.reservation_segment.id}/undo_no_show`}
                >
                  {I18n.t("undo_no_show")}
                </button>
                :
                null
              }
              </div>
            ) : (
              <div className="col-md-6 content-right flexed button-wrapper">

                <button
                  type="button"
                  className={
                    "btn btn-secondary btn-sm modal-iframe segment-card-action-button"
                  }
                  data-fullscreen="true"
                  data-nested="true"
                  href={this.props.view_segment_path}
                >
                  <span className="view-span">{I18n.t("view")}</span>
                </button>

                {this.props.reservation_segment.status == "checked_out" &&
                this.props.check_out_today &&
                !this.props.reservation_segment.reservation_segment_currently_checked_in &&
                !this.props.read_only &&
                !this.props.loading ? (
                  <button
                    type="button"
                    className={
                      "btn btn-sm btn-secondary btn-sm modal-iframe segment-card-action-button"
                    }
                    data-fullscreen="false"
                    data-nested="true"
                    href={`/admin/reservation-segments/${this.props.reservation_segment.id}/undo_check_out`}
                  >
                    {I18n.t("undo_check_out")}
                  </button>
                ) : null }
              </div>
            )}
          </div>

          {this.props.reservation_segment ? (
            <div className="panel-body container">
              <DateSection {...this.props} read_only={true} />
              <AccommodationSection {...this.props} read_only={true} />
            </div>
          ) : (
            <div className="panel-body container center-text">
              <span className="none">{I18n.t("none")}</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default RoomDetails;